import { Component } from "preact";
import { connect } from "react-redux";
import { css } from "emotion";
import { Field, reduxForm } from "redux-form";
import Button from "../../components/Button";
import InputField from "../../components/fields/InputField";
import Modal from "../../components/Modal";
import {
  checkForExistingAttendee,
  closeModal,
  unAssignTicket,
  updateProfile,
  createIdentifier
} from "../../state/actions/attendeeProfileActions";
import { email, required } from "../../utils/Validators";

const formName = "attendeeProfile";

class ProfileModal extends Component {
  handleSubmit = profileData => {
    const {
      updateProfile,
      checkForExistingAttendee,
      attendeeProfile,
      order
    } = this.props;
    const { _id } = order.data;

    const { attendeeModal } = attendeeProfile;
    const { ticketId, isNew, defaultValues } = attendeeModal;
    if (isNew) {
      checkForExistingAttendee(profileData, ticketId);
    } else {
      updateProfile(_id, defaultValues._id, profileData);
    }
  };

  render({
    attendeeProfile,
    closeModal,
    order,
    profileLookup,
    unAssignTicket,
    buyerOrderIdentifier
  }) {
    const { attendeeModal, loading, error } = attendeeProfile;
    const { show, defaultValues } = attendeeModal;
    const { _id } = order.data;
    const { creatorOrderId } = defaultValues;
    if (loading) {
      return (
        <div class="loading loading-lg" style={{ padding: "0 0 180px 0" }} />
      );
    }

    const assignedTicketTypes = profileLookup[defaultValues._id];
    const hasAssignedTicketTypes =
      assignedTicketTypes &&
      assignedTicketTypes.length &&
      assignedTicketTypes.length > 0;
    return (
      <Modal closeHandler={closeModal} showModal={show} padding={0}>
        {show ? (
          <AttendeeForm
            saveDetails={this.handleSubmit}
            defaultValues={defaultValues}
            createdByOrder={_id === creatorOrderId}
            isBuyer={defaultValues.profileIdentifier === buyerOrderIdentifier}
            errorMessage={error}
          />
        ) : null}
        {hasAssignedTicketTypes ? (
          <div
            style={{
              borderTop: "solid 1px #dedede",
              paddingTop: 16,
              paddingBottom: 16,
              paddingLeft: 20,
              paddingRight: 20
            }}
          >
            <h2 style={{ marginBottom: 16 }}>Assigned Tickets</h2>
            {assignedTicketTypes.map(ticket => {
              return (
                <div
                  style={{
                    display: "flex",
                    borderBottom: "solid 1px #dedede",
                    paddingBottom: 8,
                    marginBottom: 8
                  }}
                >
                  <div style={{ flexGrow: 1, fontSize: 14 }}>
                    {ticket.ticketTypeName}
                  </div>
                  <a
                    onClick={() =>
                      unAssignTicket(
                        ticket._id,
                        assignedTicketTypes.length === 1
                      )
                    }
                  >
                    Un-assign
                  </a>
                </div>
              );
            })}
          </div>
        ) : null}
      </Modal>
    );
  }
}

const attendeeFormStyle = css({
  minWidth: 500,
  padding: 20,
  "@media (max-width: 600px)": {
    minWidth: 0
  }
});

let AttendeeForm = ({
  handleSubmit,
  saveDetails,
  errorMessage,
  createdByOrder,
  isBuyer
}) => {
  const allowEdit = createdByOrder && !isBuyer;
  let warningMessage = "";
  if (!createdByOrder || isBuyer) {
    warningMessage = !createdByOrder
      ? "This attendee profile existed before this order, so its details cannot be changed."
      : "This attendee profile is the buyer profile, to change it please change buyer details.";
  }
  return (
    <form
      onSubmit={handleSubmit(saveDetails)}
      className={attendeeFormStyle}
      id={formName}
      style={{ overflow: "auto" }}
    >
      {warningMessage ? (
        <p style={{ marginTop: 12 }}>{warningMessage}</p>
      ) : null}
      <Field
        label="First Name"
        type="text"
        name={`firstName`}
        component={InputField}
        required={true}
        validate={[required]}
        disabled={!allowEdit}
      />
      <Field
        label="Last Name"
        type="text"
        name={`lastName`}
        component={InputField}
        required={true}
        validate={[required]}
        disabled={!allowEdit}
      />
      <Field
        label="Email"
        type="text"
        name={`email`}
        component={InputField}
        required={true}
        validate={[required, email]}
        autocomplete="email"
        disabled={!allowEdit}
      />
      {errorMessage ? <p class="text-error">{errorMessage}</p> : null}
      {/* Hide submit button, but render it to allow submit on enter */}
      <div style={{ float: "right" }}>
        <Button
          key="payment"
          buttonType="submit"
          form={formName}
          ariaLabel="modalSubmit"
          value="Submit"
          type="primary"
          dataCY="submit"
        >
          Save
        </Button>
      </div>
    </form>
  );
};

AttendeeForm = reduxForm({
  form: formName,
  destroyOnUnmount: true,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(AttendeeForm);

AttendeeForm = connect((state, ownProps) => {
  return {
    initialValues: ownProps.defaultValues
  };
})(AttendeeForm);

export default connect(
  (state, ownProps) => {
    return {
      event: state.event,
      order: state.order,
      attendeeProfile: state.attendeeProfile,
      buyerOrderIdentifier: createIdentifier(state.order.data)
    };
  },
  {
    checkForExistingAttendee,
    closeModal,
    updateProfile,
    unAssignTicket
  }
)(ProfileModal);



// WEBPACK FOOTER //
// ./routes/conferences/ProfileModal.js